import { FilterBar } from '@framework/ui/components/search/filter-bar/FilterBar.tsx';
import { type CommunicationListProps } from '../CommunicationList.tsx';
import { communicationSortingFields } from '../table/hooks/useCommunicationColumns.tsx';
import { CommunicationsSearchSchema } from '../toolbar/CommunicationSearchSchema.ts';
import { useCommunicationSearchableFields } from '../toolbar/hooks/useCommunicationSearchableFields.tsx';

interface ICommunicationAdvancedSearchProps
  extends Pick<
    CommunicationListProps,
    'query' | 'defaultQuery' | 'setQuery' | 'isBackoffice' | 'total'
  > {}

/**
 * Componente centralizzato per la ricerca avanzata delle comunicazioni
 */
export function CommunicationAdvancedSearch(
  props: ICommunicationAdvancedSearchProps,
) {
  const { query, defaultQuery, setQuery, isBackoffice, total } = props;

  const searchableFields = useCommunicationSearchableFields({
    isBackoffice: !!isBackoffice,
  });

  return (
    <FilterBar
      id="communication-list-search"
      query={query}
      defaultQuery={defaultQuery}
      setQuery={setQuery}
      fields={searchableFields}
      pageKey="pagina"
      total={total}
      schema={CommunicationsSearchSchema}
      // Per le comunicazioni, non salviamo la ricerca
      disableLocalStorage
      // L'ordinamento viene reso dal chip "Ordinamento" nativo della FilterBar.
      sortingFields={communicationSortingFields}
      layout={{ showInCard: true }}
    />
  );
}
